<template>
  <Transition name="fade">
    <div v-if="show" class="splash-screen">
      <img src="/images/splash.jpg" alt="Starvly" class="splash-image" />
    </div>
  </Transition>
</template>

<script setup>
const show = ref(true)

onMounted(() => {
  setTimeout(() => {
    show.value = false
  }, 4000)
})
</script>

<style scoped>
.splash-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
}

.splash-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
